(() => {
  const doc = document;
  const body = doc.body;
  const qs = (s, c = doc) => c.querySelector(s);
  const qsa = (s, c = doc) => [...c.querySelectorAll(s)];
  const money = (cents) => {
    const format = window.themeSettings?.moneyFormat || '${{ amount }}';
    const value = Number(cents || 0) / 100;
    const withDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      const parts = Number(number).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    const token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [,'amount'])[1];
    const values = {
      amount: withDelimiters(value, 2),
      amount_no_decimals: withDelimiters(value, 0),
      amount_with_comma_separator: withDelimiters(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiters(value, 0, '.', ','),
      amount_with_space_separator: withDelimiters(value, 2, ' ', ','),
      amount_no_decimals_with_space_separator: withDelimiters(value, 0, ' '),
      amount_with_apostrophe_separator: withDelimiters(value, 2, "'", '.')
    };
    return format.replace(/\{\{\s*\w+\s*\}\}/, values[token] || values.amount);
  };
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const lock = (state) => body.classList.toggle('is-locked', state);
  const toast = (message) => {
    const el = qs('.toast'); if (!el) return;
    el.textContent = message; el.classList.add('is-visible');
    clearTimeout(window.__toastTimer); window.__toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
  };

  function initReveal(scope = doc) {
    const els = qsa('[data-reveal]:not(.is-observed)', scope);
    if (!window.themeSettings?.animations || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(el => el.classList.add('is-visible')); return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });
    els.forEach((el, i) => { el.classList.add('is-observed'); el.style.transitionDelay = `${Math.min(i % 5, 4) * 70}ms`; observer.observe(el); });
  }

  function initParallax() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = qsa('[data-parallax]'); if (!els.length) return;
    let ticking = false;
    const update = () => {
      const vh = innerHeight;
      els.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const speed = Number(el.dataset.parallax || .08);
        const y = (rect.top + rect.height / 2 - vh / 2) * speed;
        el.style.transform = `translate3d(0,${y}px,0) scale(1.04)`;
      }); ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true }); update();
  }

  function initHeader() {
    const header = qs('.site-header'); if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 20);
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  function openLayer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); }
  function closeLayer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); if (!qs('.is-open.mobile-menu,.is-open.search-overlay,.is-open.cart-drawer,.is-open.filter-drawer')) lock(false); }

  function initLayers(scope = doc) {
    qsa('[data-open-mobile-menu]', scope).forEach(btn => btn.addEventListener('click', () => openLayer(qs('.mobile-menu'))));
    qsa('[data-close-mobile-menu]', scope).forEach(btn => btn.addEventListener('click', () => closeLayer(qs('.mobile-menu'))));
    qsa('[data-open-search]', scope).forEach(btn => btn.addEventListener('click', () => { const el = qs('.search-overlay'); openLayer(el); setTimeout(() => qs('input', el)?.focus(), 200); }));
    qsa('[data-close-search]', scope).forEach(btn => btn.addEventListener('click', () => closeLayer(qs('.search-overlay'))));
    qsa('[data-open-cart]', scope).forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); openCart(); }));
    qsa('[data-close-cart]', scope).forEach(btn => btn.addEventListener('click', () => closeLayer(qs('.cart-drawer'))));
    qsa('[data-open-filter]', scope).forEach(btn => btn.addEventListener('click', () => openLayer(qs('.filter-drawer'))));
    qsa('[data-close-filter]', scope).forEach(btn => btn.addEventListener('click', () => closeLayer(qs('.filter-drawer'))));
  }

  async function getCart() { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw new Error('Unable to load cart'); return r.json(); }
  function cartItemMarkup(item) {
    const image = item.image ? `<img class="cart-drawer__image" src="${item.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_260x$1')}" alt="${escapeHTML(item.product_title)}">` : '';
    const options = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__variant">${escapeHTML(item.variant_title).replace(/ \/ /g,' · ')}</p>` : '';
    return `<article class="cart-drawer__item" data-key="${escapeHTML(item.key)}">
      <a class="cart-drawer__media" href="${item.url}">${image}<span class="cart-drawer__media-frame" aria-hidden="true"></span></a>
      <div class="cart-drawer__details">
        <p class="cart-drawer__item-kicker">The Hair Vault &amp; Co.</p>
        <a class="cart-drawer__title" href="${item.url}">${escapeHTML(item.product_title)}</a>
        ${options}
        <div class="cart-drawer__item-bottom">
          <div class="cart-drawer__qty" aria-label="Quantity"><button type="button" data-cart-change="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
          <strong class="cart-drawer__line-price">${money(item.final_line_price)}</strong>
        </div>
        <button class="cart-drawer__remove" type="button" data-cart-change="0">Remove</button>
      </div>
    </article>`;
  }
  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    qsa('[data-cart-item-count]').forEach(el => { el.textContent = cart.item_count; });
    const items = qs('[data-cart-items]'); const footer = qs('[data-cart-footer]'); if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = '<div class="cart-drawer__empty"><span class="cart-drawer__empty-mark">HV</span><h3>Your vault is waiting.</h3><p>Discover premium wigs, lace and bundles selected for a flawless finish.</p><a class="button button--light button--full" href="/collections/all">Explore the collection</a></div>';
      if (footer) footer.hidden = true;
    } else {
      items.innerHTML = cart.items.map(cartItemMarkup).join('');
      if (footer) { footer.hidden = false; qs('[data-cart-subtotal]', footer).textContent = money(cart.total_price); }
    }
  }
  async function openCart() { try { renderCart(await getCart()); openLayer(qs('.cart-drawer')); } catch (e) { location.href = '/cart'; } }
  async function changeCart(key, quantity) {
    const r = await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity}) });
    if (!r.ok) throw new Error('Cart update failed'); renderCart(await r.json());
  }
  function initCartEvents() {
    doc.addEventListener('click', e => {
      const button = e.target.closest('[data-cart-change]'); if (!button) return;
      const item = button.closest('[data-key]'); if (!item) return;
      button.disabled = true; changeCart(item.dataset.key, Number(button.dataset.cartChange)).catch(() => toast('Unable to update cart.')).finally(() => button.disabled = false);
    });
  }

  function initProductForms(scope = doc) {
    const roots = scope.matches?.('[data-product-root]') ? [scope] : qsa('[data-product-root]', scope);

    roots.forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';

      const productUrl = root.dataset.productUrl || location.pathname;
      const sectionId = root.dataset.sectionId;
      const selects = qsa('[data-option-select]', root);
      const groups = qsa('[data-option-group]', root);
      const sticky = qs('[data-sticky-add]', root);
      const mediaItems = qsa('[data-product-media]', root);
      const mediaThumbs = qsa('[data-product-thumb]', root);
      let optionRequestController = null;

      const selectMedia = index => {
        if (!mediaItems.length) return;
        mediaItems.forEach((item, i) => item.classList.toggle('is-active', i === index));
        mediaThumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        if (matchMedia('(max-width: 800px)').matches) {
          mediaItems[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      };

      mediaThumbs.forEach(thumb => thumb.addEventListener('click', () => selectMedia(Number(thumb.dataset.productThumb || 0))));

      const selectedOptionValueIds = () => selects.map(select => select.value).filter(Boolean);

      // Hair Vault extended-length rule:
      // 32–40 inch variants exist only at 180% density. The CSV contains no 150% or
      // 260% variants at those lengths. Keep 180% high-variant values selectable, but
      // remove 32–40 from the Length UI whenever 150% or 260% is selected.
      const optionGroupByName = name => groups.find(group =>
        (group.dataset.optionName || '').trim().toLowerCase() === name.toLowerCase()
      );

      const selectedValueForGroup = group => {
        if (!group) return '';
        const selected = qs('[data-option-pill].is-selected', group);
        return (selected?.dataset.optionValue || '').trim();
      };

      const setGroupSelection = (group, pill) => {
        if (!group || !pill) return;
        const groupIndex = groups.indexOf(group);
        qsa('[data-option-pill]', group).forEach(item => {
          const selected = item === pill;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        const label = qs('[data-selected-option]', group);
        if (label) label.textContent = pill.dataset.optionValue || '';
        const select = selects[groupIndex];
        if (select) select.value = pill.dataset.optionValueId || '';
      };

      const isExtendedLength = value => {
        const length = parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
        return Number.isFinite(length) && length >= 32 && length <= 40;
      };

      const normalizeExtendedLengthSelection = nextDensity => {
        if (!nextDensity || nextDensity === '180%') return;
        const lengthGroup = optionGroupByName('Length');
        if (!lengthGroup) return;
        const currentLength = selectedValueForGroup(lengthGroup);
        if (!isExtendedLength(currentLength)) return;

        const fallbackPills = qsa('[data-option-pill]', lengthGroup)
          .filter(pill => !isExtendedLength(pill.dataset.optionValue))
          .sort((a, b) => {
            const av = parseInt(String(a.dataset.optionValue || '').replace(/[^0-9]/g, ''), 10) || 0;
            const bv = parseInt(String(b.dataset.optionValue || '').replace(/[^0-9]/g, ''), 10) || 0;
            return bv - av;
          });
        const fallback = fallbackPills[0];
        if (fallback) setGroupSelection(lengthGroup, fallback);
      };

      const applyClientOptionRules = () => {
        // First clear visual locking caused by Shopify's deferred high-variant state.
        qsa('[data-option-select] option', root).forEach(option => { option.disabled = false; });
        qsa('[data-option-pill]', root).forEach(pill => {
          pill.disabled = false;
          pill.setAttribute('aria-disabled', 'false');
          pill.classList.remove('is-sold-out', 'is-rule-hidden');
          pill.removeAttribute('hidden');
        });

        if (root.dataset.extendedLengthDensityRule !== '180-only') return;
        const densityGroup = optionGroupByName('Density');
        const lengthGroup = optionGroupByName('Length');
        if (!densityGroup || !lengthGroup) return;

        const density = selectedValueForGroup(densityGroup);
        const showExtended = density === '180%';
        const lengthGroupIndex = groups.indexOf(lengthGroup);
        const lengthSelect = selects[lengthGroupIndex];

        qsa('[data-option-pill]', lengthGroup).forEach(pill => {
          if (!isExtendedLength(pill.dataset.optionValue)) return;
          const shouldHide = !showExtended;
          pill.classList.toggle('is-rule-hidden', shouldHide);
          pill.hidden = shouldHide;
          pill.disabled = shouldHide;
          pill.setAttribute('aria-disabled', shouldHide ? 'true' : 'false');

          if (lengthSelect) {
            const option = qsa('option', lengthSelect).find(item => item.value === pill.dataset.optionValueId);
            if (option) option.disabled = shouldHide;
          }
        });
      };

      applyClientOptionRules();

      const setLoading = loading => {
        root.classList.toggle('is-updating', loading);
        root.setAttribute('aria-busy', loading ? 'true' : 'false');
        qsa('[data-option-pill]', root).forEach(pill => { pill.disabled = loading || pill.classList.contains('is-rule-hidden'); });
        if (!loading) applyClientOptionRules();
      };

      const replaceProductSection = async (optionIndex, optionValueId, optionValueName) => {
        const select = selects[optionIndex];
        if (!select || !optionValueId || !sectionId) return;

        select.value = optionValueId;
        const selectedIds = selectedOptionValueIds();
        if (selectedIds.length !== selects.length) return;

        const productStateUrl = new URL(productUrl, location.origin);
        productStateUrl.searchParams.set('option_values', selectedIds.join(','));
        const sectionUrl = new URL(productStateUrl);
        sectionUrl.searchParams.set('section_id', sectionId);

        optionRequestController?.abort();
        optionRequestController = new AbortController();
        setLoading(true);

        try {
          const response = await fetch(`${sectionUrl.pathname}${sectionUrl.search}`, {
            headers: { Accept: 'text/html' },
            signal: optionRequestController.signal
          });
          if (!response.ok) throw new Error('Unable to load this option combination.');

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.querySelector('[data-product-root]');
          if (!replacement) throw new Error('The selected option could not be rendered.');

          root.replaceWith(replacement);
          history.replaceState({}, '', `${productStateUrl.pathname}${productStateUrl.search}${location.hash}`);
          initProductForms(replacement);
          initReveal(replacement);
          initAccordions(replacement);
          const refreshedPill = qsa('[data-option-group]', replacement)[optionIndex]
            ?.querySelector(`[data-option-value-id="${CSS.escape(String(optionValueId))}"]`);
          refreshedPill?.focus();
        } catch (error) {
          if (error.name !== 'AbortError') {
            setLoading(false);
            toast(error.message || 'Unable to update product options.');
          }
        }
      };

      groups.forEach((group, optionIndex) => {
        qsa('[data-option-pill]', group).forEach(pill => {
          pill.addEventListener('click', () => {
            if (root.classList.contains('is-updating') || pill.classList.contains('is-rule-hidden')) return;

            const optionName = (group.dataset.optionName || '').trim().toLowerCase();
            if (optionName === 'density') {
              normalizeExtendedLengthSelection((pill.dataset.optionValue || '').trim());
            }

            setGroupSelection(group, pill);
            applyClientOptionRules();
            replaceProductSection(optionIndex, pill.dataset.optionValueId, pill.dataset.optionValue);
          });
        });
      });

      qsa('[data-qty-minus]', root).forEach(btn => btn.addEventListener('click', () => {
        const input = qs('[data-qty-input]', root);
        if (input) input.value = Math.max(1, Number(input.value) - 1);
      }));
      qsa('[data-qty-plus]', root).forEach(btn => btn.addEventListener('click', () => {
        const input = qs('[data-qty-input]', root);
        if (input) input.value = Math.min(99, Number(input.value) + 1);
      }));

      qsa('.js-product-form', root).forEach(form => form.addEventListener('submit', async event => {
        if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
        event.preventDefault();
        const button = qs('[data-add-to-cart]', form);
        const original = button?.textContent;
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) { const err = await response.json(); throw new Error(err.description || 'Could not add item'); }
          renderCart(await getCart());
          openLayer(qs('.cart-drawer'));
          toast('Added to your vault.');
        } catch (err) {
          toast(err.message);
        } finally {
          if (button) { button.disabled = false; button.textContent = original; }
        }
      }));

      if (sticky) sticky.addEventListener('click', () => qs('[data-add-to-cart]', root)?.click());
    });
  }


  function initDiscountCopy(scope = doc) {
    qsa('[data-copy-discount]:not([data-copy-bound])', scope).forEach(button => {
      button.dataset.copyBound = 'true';
      button.addEventListener('click', async () => {
        const code = button.dataset.discountCode || 'VAULT10';
        try {
          await navigator.clipboard.writeText(code);
          button.classList.add('is-copied');
          toast(`Discount code ${code} copied.`);
          setTimeout(() => button.classList.remove('is-copied'), 1800);
        } catch (error) {
          toast(`Use discount code ${code} at checkout.`);
        }
      });
    });
  }

  function initCartPage(scope = doc) {
    qsa('[data-cart-page-line]', scope).forEach(line => {
      const input = qs('[data-cart-page-input]', line);
      if (!input || input.dataset.bound) return;
      input.dataset.bound = '1';
      qs('[data-cart-page-minus]', line)?.addEventListener('click', () => { input.value = Math.max(0, Number(input.value || 0) - 1); });
      qs('[data-cart-page-plus]', line)?.addEventListener('click', () => { input.value = Math.min(99, Number(input.value || 0) + 1); });
    });
  }

  function initAccordions(scope = doc) { qsa('[data-accordion-button]', scope).forEach(btn => { if (btn.dataset.bound) return; btn.dataset.bound='1'; btn.addEventListener('click', () => { const item=btn.closest('.accordion__item'); const open=item.classList.toggle('is-open'); btn.setAttribute('aria-expanded',open); }); }); }
  function initTestimonials(scope = doc) {
    qsa('[data-testimonial-slider]', scope).forEach(slider => {
      if (slider.dataset.bound) return; slider.dataset.bound='1';
      const slides=qsa('.testimonial',slider),dots=qsa('[data-testimonial-dot]',slider); let index=0;
      const show=i=>{index=i;slides.forEach((s,n)=>s.classList.toggle('is-active',n===i));dots.forEach((d,n)=>d.classList.toggle('is-active',n===i));};
      dots.forEach((d,i)=>d.addEventListener('click',()=>show(i))); show(0);
      if(slider.dataset.autoplay==='true'&&slides.length>1&&!matchMedia('(prefers-reduced-motion: reduce)').matches)setInterval(()=>show((index+1)%slides.length),6000);
    });
  }
  function initSort(scope=doc){qsa('[data-sort-by]',scope).forEach(select=>select.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',select.value);location.href=u;}));}
  function initPageTransition(){
    if(!window.themeSettings?.pageTransition||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    doc.addEventListener('click',e=>{
      if(e.defaultPrevented)return;
      const a=e.target.closest('a');
      if(!a||a.matches('[data-open-cart]')||a.target==='_blank'||a.hasAttribute('download')||a.href.startsWith('mailto:')||a.href.startsWith('tel:')||(a.hash&&a.pathname===location.pathname)||a.hostname!==location.hostname||e.metaKey||e.ctrlKey)return;
      e.preventDefault();body.classList.add('is-transitioning');setTimeout(()=>location.href=a.href,430);
    });
    addEventListener('pageshow',()=>body.classList.remove('is-transitioning'));
  }
  function initCursor(){const glow=qs('.cursor-glow');if(!glow||!window.themeSettings?.cursorGlow||matchMedia('(pointer:coarse)').matches)return;addEventListener('mousemove',e=>{glow.style.left=`${e.clientX}px`;glow.style.top=`${e.clientY}px`;glow.classList.add('is-visible');},{passive:true});addEventListener('mouseleave',()=>glow.classList.remove('is-visible'));}
  function initSplitHeadings(scope = doc) {
    const headings = qsa('[data-split-heading]:not([data-split-ready])', scope);
    headings.forEach(heading => {
      heading.dataset.splitReady = 'true';
      const walker = doc.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.trim()) nodes.push(walker.currentNode);
      }
      nodes.forEach(node => {
        const fragment = doc.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            fragment.appendChild(doc.createTextNode(part));
          } else {
            const outer = doc.createElement('span');
            const inner = doc.createElement('span');
            outer.className = 'split-word';
            inner.textContent = part;
            outer.appendChild(inner);
            fragment.appendChild(outer);
          }
        });
        node.parentNode.replaceChild(fragment, node);
      });
      if (!window.themeSettings?.animations || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        heading.classList.add('is-split-visible');
        return;
      }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-split-visible');
          observer.unobserve(entry.target);
        }
      }), { threshold: .18, rootMargin: '0px 0px -8% 0px' });
      observer.observe(heading);
    });
  }

  function initTiltCards(scope = doc) {
    if (matchMedia('(pointer: coarse)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    qsa('[data-tilt-card]:not([data-tilt-bound])', scope).forEach(card => {
      card.dataset.tiltBound = 'true';
      card.addEventListener('pointermove', event => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        card.style.transform = `perspective(1100px) rotateX(${(-y * 4).toFixed(2)}deg) rotateY(${(x * 5).toFixed(2)}deg) translateY(-3px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  function initMagneticButtons(scope = doc) {
    if (matchMedia('(pointer: coarse)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    qsa('.button--magnetic:not([data-magnetic-bound])', scope).forEach(button => {
      button.dataset.magneticBound = 'true';
      button.addEventListener('pointermove', event => {
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left - rect.width / 2;
        const y = event.clientY - rect.top - rect.height / 2;
        button.style.transform = `translate3d(${(x * .12).toFixed(1)}px,${(y * .16 - 2).toFixed(1)}px,0)`;
      });
      button.addEventListener('pointerleave', () => { button.style.transform = ''; });
    });
  }

  function initVaultStories(scope = doc) {
    qsa('[data-vault-story]:not([data-vault-story-bound])', scope).forEach(root => {
      root.dataset.vaultStoryBound = 'true';
      const scenes = qsa('[data-vault-story-scene]', root);
      const tabs = qsa('[data-vault-story-tab]', root);
      const progress = qs('[data-vault-story-progress]', root);
      if (!scenes.length) return;
      const activate = index => {
        scenes.forEach((scene, i) => scene.classList.toggle('is-active', i === index));
        tabs.forEach((tab, i) => {
          tab.classList.toggle('is-active', i === index);
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      };
      tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        scenes[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        activate(index);
      }));
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(Number(visible.target.dataset.vaultStoryScene));
      }, { threshold: [.15, .3, .5, .7], rootMargin: '-18% 0px -28% 0px' });
      scenes.forEach(scene => observer.observe(scene));
      let ticking = false;
      const updateProgress = () => {
        const rect = root.getBoundingClientRect();
        const range = Math.max(1, rect.height - innerHeight);
        const value = Math.max(0, Math.min(1, -rect.top / range));
        if (progress) progress.style.width = `${value * 100}%`;
        ticking = false;
      };
      addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(updateProgress); ticking = true; }
      }, { passive: true });
      updateProgress();
      activate(0);
    });
  }

  function initFilmstrips(scope = doc) {
    qsa('[data-filmstrip]:not([data-filmstrip-bound])', scope).forEach(root => {
      root.dataset.filmstripBound = 'true';
      const viewport = qs('[data-filmstrip-viewport]', root);
      if (!viewport) return;
      const amount = () => Math.max(280, viewport.clientWidth * .72);
      qs('[data-filmstrip-prev]', root)?.addEventListener('click', () => viewport.scrollBy({ left: -amount(), behavior: 'smooth' }));
      qs('[data-filmstrip-next]', root)?.addEventListener('click', () => viewport.scrollBy({ left: amount(), behavior: 'smooth' }));
      viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') viewport.scrollBy({ left: amount(), behavior: 'smooth' });
        if (event.key === 'ArrowLeft') viewport.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
      let dragging = false, startX = 0, startScroll = 0;
      viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') return;
        dragging = true; startX = event.clientX; startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging'); viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', event => {
        if (!dragging) return;
        viewport.scrollLeft = startScroll - (event.clientX - startX) * 1.15;
      });
      const stop = event => {
        if (!dragging) return;
        dragging = false; viewport.classList.remove('is-dragging');
        if (event?.pointerId != null && viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      };
      viewport.addEventListener('pointerup', stop);
      viewport.addEventListener('pointercancel', stop);
      viewport.addEventListener('pointerleave', event => { if (dragging) stop(event); });
    });
  }

  function initAll(scope=doc){initReveal(scope);initDiscountCopy(scope);initSplitHeadings(scope);initLayers(scope);initProductForms(scope);initCartPage(scope);initAccordions(scope);initTestimonials(scope);initSort(scope);initTiltCards(scope);initMagneticButtons(scope);initVaultStories(scope);initFilmstrips(scope);}
  addEventListener('DOMContentLoaded',()=>{initAll();initParallax();initHeader();initCartEvents();initPageTransition();initCursor();});
  doc.addEventListener('shopify:section:load',e=>initAll(e.target));
  doc.addEventListener('keydown',e=>{if(e.key==='Escape')qsa('.is-open.mobile-menu,.is-open.search-overlay,.is-open.cart-drawer,.is-open.filter-drawer').forEach(closeLayer);});
})();
